/*global ajaxurl */
import axios from 'axios';
import Qs from 'qs';

export default {
  init() {

    console.log('here')

    // JavaScript to be fired on the about us page

    $('#mou-select a').on('click', function(e) {
      e.preventDefault()

        $('#mou-select a').removeClass('active')
        $(this).addClass('active')

        const pageId = $(this).data('id')
        const data = {
          action: 'get_mou_content',
          id: pageId,
        }

        axios.post(ajaxurl, Qs.stringify(data)).then(response => {
          const content = response.data.data.content
          const permalink = response.data.data.permalink
          $('#mou-content').empty()
          $('#mou-content').append(content)

          $('.mou-success').removeClass('active')
          $('.mou-success').each(function() {
            if($(this).attr('id') === permalink) {
              $(this).addClass('active')
            }
          })
        })
    })
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/mou.js